export const ToastrOptions = {
    closeButton: true,
    enableHtml: true,
    positionClass: 'toast-bottom-center',
    progressBar: true
};
